import React, { Component } from "react";
import PropTypes from "prop-types";
import { TitleCase2 } from "../../common";
import { Form, Button } from "semantic-ui-react";
import { bindActionCreators } from "redux";
import RepeatingFormLineItem from "../RepeatingFormLineItem";
import { connect } from "react-redux";
import * as AppActions from "../../actions";
import ControlTitle from "../ControlTitle";
import _ from "lodash";

const uuidv4 = require("uuid/v1");

class RepeatingForm extends Component {
  shouldComponentUpdate(nextProps) {
    return true;
  }

  handleClick(index, e) {
    const { element_prompt, repeatingFormEdit, ...formControl } = this.props;
    var uuid = uuidv4();
    this.props.actions.setRepeatingForm(
      formControl.element_id,
      uuid,
      index,
      repeatingFormEdit,
      element_prompt
    );
  }

  handleSelect(uuid, index) {
    const { element_prompt, ...formControl } = this.props;

    this.props.actions.setRepeatingForm(
      formControl.element_id,
      uuid,
      index,
      true,
      element_prompt
    );
  }

  renderButton(lineItemArray, value, max) {
    const { validate, error, ...formControl } = this.props;
    let title = formControl.element_params.N;

    if (Number(value) === max) {
      return null;
    }

    var repeatingFormItemsX = _.filter(this.props.draft, function(control) {
      return Number(control.repeatingFormId) === Number(formControl.element_id);
    });

    let nTitle = "";
    if (title !== undefined) {
      nTitle = TitleCase2(title.replace("+", "").trim());
    }

    if (validate && error && repeatingFormItemsX.length === 0) {
      return (
        <div className="errorBox">
          <Button
            className="ui button"
            ref="UnToggle"
            role="button"
            onClick={this.handleClick.bind(this, lineItemArray.length + 1)}
            active
          >
            {nTitle}
          </Button>
        </div>
      );
    }
    return (
      <Button
        className="ui button"
        ref="UnToggle"
        role="button"
        onClick={this.handleClick.bind(this, lineItemArray.length + 1)}
        active
      >
        {nTitle}
      </Button>
    );
  }

  render() {
    const {
      element_prompt,
      element_value,
      element_id,
      draft,
      formControls,
      ...formControl
    } = this.props;
    var lineItemArray = [];

    var repeatingFormItemsX = _.filter(draft, function(control) {
      return Number(control.repeatingFormId) === Number(element_id);
    });

    let max = Number(formControl.element_params.H);

    repeatingFormItemsX = _.sortBy(repeatingFormItemsX, "repeatingFormIndex");
    var test = _(repeatingFormItemsX)
      .map("repeatingFormUUID")
      .uniq()
      .value();

    test.forEach((element, index) => {
      var lineObject = [];

      var repeatingFormItems = _.filter(draft, function(control) {
        return (
          Number(control.repeatingFormId) === Number(element_id) &&
          control.repeatingFormUUID === element
        );
      });

      repeatingFormItems.forEach(element => {
        lineObject.push({
          element_id: element.element_id,
          element_value: element.element_value
        });
      });

      lineItemArray.push(
        <RepeatingFormLineItem
          title={element_prompt}
          onClick={this.handleSelect.bind(this)}
          key={index}
          index={index + 1}
          uuid={element}
          storeColour={this.props.storeColour}
          lineItem={lineObject}
        />
      );
    });

    var valItem = _.filter(this.props.draft, function(control) {
      return Number(control.element_id) === Number(element_id);
    });

    let val = 0;
    if (valItem.length > 0) {
      val = valItem[0].element_value;
    }

    return (
      <div className="formControlItem">
        <Form.Field>
          <ControlTitle
            text={element_prompt}
            optional={formControl.element_optional === "1" ? true : false}
          ></ControlTitle>
          <div>
            {lineItemArray}
            {this.renderButton(lineItemArray, val, max)}
          </div>
        </Form.Field>
      </div>
    );
  }
}

RepeatingForm.propTypes = {
  element_prompt: PropTypes.string.isRequired,
  element_value: PropTypes.string.isRequired,
  storeColour: PropTypes.object.isRequired
};

const mapStateToProps = state => ({
  draft: state.form.draft,
  repeatingFormEdit: state.form.repeatingFormEdit,
  repeatingFormId: state.form.repeatingFormId,
  formControls: state.form.data
});

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(AppActions, dispatch)
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(RepeatingForm);



// WEBPACK FOOTER //
// ./src/components/RepeatingForm/index.js